import axios from 'axios';

const updateNotificationSettings = async (notificationSettings: {
  showingStarted: boolean;
  lockboxAssignmentReminder: boolean;
  userId: string;
}) => {
  await axios.post<{ error?: string }>(
    '/supra_system/subscription/notification_settings',
    notificationSettings,
  );
};

export default updateNotificationSettings;
